module.exports = __webpack_public_path__ + "img/icon-sb-clock-orange-boutique-24x24.ed855c6.svg";